var _style, _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNeurotolge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-neurotolge",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 26 26",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "#icon-neurotolge .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#282828}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22 11h-6V4c0-2.2-1.8-4-4-4H4C1.8 0 0 1.8 0 4v7c0 2.2 1.8 4 4 4h6v7c0 2.2 1.8 4 4 4h8c2.2 0 4-1.8 4-4v-7c0-2.2-1.8-4-4-4zM2 11V4c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v7c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2zm22 11c0 1.1-.9 2-2 2h-8c-1.1 0-2-.9-2-2v-7c1.5 0 2.7-.8 3.4-2H22c1.1 0 2 .9 2 2v7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5 15H19v-1h-2v1h-.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5h.5v1h2v-1h.5c1.9 0 3.5-1.6 3.5-3.5S21.4 15 19.5 15zm-3 5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h.5v3h-.5zm3 0H19v-3h.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zM11 12h2.1L9 3.7c-.1-.2-.3-.4-.5-.5-.5-.2-1.2 0-1.5.5L2.9 12H5l1.2-2.3h3.7L11 12zM7.2 7.7 8 6.2s.1-.1.1 0l.8 1.5H7.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 4,
    cy: 4,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12,
    cy: 4,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNeurotolge);
export default __webpack_public_path__ + "static/media/icon-neurotolge.8eb43aedccd70e3c7116c68423623dd0.svg";
export { ForwardRef as ReactComponent };